<template lang="pug">
dialog-base(
  v-bind="attrs"
  v-on="$listeners"
)
  portal(:to="`${constants.DIALOG_PORTAL_KEY}.content`")
    .d-flex.flex-column.gap-16
      .d-flex.gap-12
        phone-input(
          v-model="phone"
        )
        app-button(
          :disabled="!isPhoneFulfilled"
          rounded
          @click="sendTelegramCode"
        ) Получить код
      .d-flex.flex-column.gap-8
        span.text-body-1 Код подтверждения
        v-otp-input(
          v-model="code"
          type="number"
          :length="constants.VERIFICATION_CODE_LENGTH"
          :disabled="!isCodeSended"
        )
  portal(:to="`${constants.DIALOG_PORTAL_KEY}.actions`")
    app-button(
      :disabled="!isCodeFulfilled"
      rounded
      block
      @click="telegramSignIn"
    ) Войти
</template>

<script>
import DialogBase from './DialogBase.vue';
import PhoneInput from '@/components/user-redesign/inputs/PhoneInput.vue';

const VERIFICATION_CODE_LENGTH = 6;
const PHONE_LENGTH = 11;
const DIALOG_PORTAL_KEY = 'telegram-phone-dialog';

export default {
  name: 'PhoneDialog',
  components: {
    DialogBase,
    PhoneInput,
  },
  props: {},
  data() {
    return {
      phone: '',
      code: '',
      isCodeSended: false,
    };
  },
  computed: {
    constants() {
      return {
        VERIFICATION_CODE_LENGTH,
        DIALOG_PORTAL_KEY,
      };
    },
    attrs() {
      return {
        ...this.$attrs,
        portalKey: DIALOG_PORTAL_KEY,
      };
    },
    normalizedCodeValue() {
      return this.code && parseInt(this.code);
    },
    isPhoneFulfilled() {
      return this.phone.length === PHONE_LENGTH;
    },
    isCodeFulfilled() {
      return this.code.length === VERIFICATION_CODE_LENGTH;
    },
  },
  watch: {},
  created() {},
  methods: {
    sendTelegramCode() {
      if (this.isCodeSended) {
        return;
      }
      const payload = {
        phone_number: this.phone,
      };

      this.$rApi.telegram.sendAuthCode({ data: payload }).then(({ error }) => {
        if (error) {
          return;
        }

        this.isCodeSended = true;
        this.$toast.success('Код отправлен в бота');
      });
    },
    telegramSignIn() {
      if (!this.isCodeSended) {
        return;
      }
      const payload = {
        code: this.normalizedCodeValue,
      };

      this.$rApi.auth.authWithTelegram({ data: payload }).then(({ response, error }) => {
        if (error) {
          return;
        }

        this.$emit('auth', response);
      });
    },
  },
};
</script>
